import data from "./data";
import WplywyTable from "./table";
const Wplywy = () => {
    return (
      <>
        <WplywyTable></WplywyTable>
      </>
    );
  };
  export default Wplywy;